import React from 'react';

export default function PrivacyContent() {
  return (
    <div className="space-y-6 text-zinc-600 dark:text-slate-300 text-xs leading-relaxed">
      <div>
        <p>
          A sua privacidade é uma prioridade para o R-Max. Este documento descreve de forma clara e transparente como coletamos, utilizamos, armazenamos, compartilhamos e protegemos os seus dados pessoais, em plena conformidade com a Lei nº 13.709/2018 (Lei Geral de Proteção de Dados – LGPD) e demais normas aplicáveis.
        </p>
        <p className="mt-2">
          Ao utilizar o aplicativo R-Max, você concorda com os termos desta Política de Privacidade. Caso não concorde, solicitamos que não utilize a plataforma.
        </p>
      </div>

      <div>
        <h3 className="font-bold text-zinc-900 dark:text-white text-sm mb-2">1. QUEM SOMOS (CONTROLADOR DE DADOS)</h3>
        <p>
          O aplicativo R-Max é desenvolvido e operado por 68.894.015 MAXIMILIANO PIERIN NETO (RESOLV MAX), pessoa jurídica de direito privado inscrita no CNPJ sob o nº 68.894.015/0001-84, com sede em Rua dos Satélites, 428, Condomínio Fechado Village Haras São Luiz – Salto/SP – CEP 13329-130.
        </p>
        <p className="mt-2">Para os fins da LGPD (art. 5º, VI), o R-Max atua como:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>CONTROLADOR:</strong> em relação aos dados cadastrais e de uso dos próprios usuários da plataforma.</li>
          <li><strong>OPERADOR:</strong> em relação aos dados de terceiros (ex.: clientes finais) inseridos pelos usuários na plataforma.</li>
        </ul>
        <p className="mt-2">
          Encarregado de Dados (DPO): Maximiliano Pierin Neto – harpy@resolvmax.com.br
        </p>
      </div>

      <div>
        <h3 className="font-bold text-zinc-900 dark:text-white text-sm mb-2">2. QUAIS DADOS PESSOAIS COLETAMOS</h3>
        <h4 className="font-bold text-zinc-800 dark:text-slate-200 mt-2 mb-1">2.1. Dados fornecidos diretamente pelo usuário</h4>
        <ul className="list-disc pl-5 space-y-1 mb-2">
          <li>Dados de identificação e cadastro: nome completo, CPF ou CNPJ, endereço de e-mail e telefone.</li>
          <li>Dados financeiros e comerciais: custos de produtos e serviços, margens de lucro, histórico de orçamentos emitidos e demais informações financeiras inseridas na plataforma.</li>
          <li>Dados de clientes finais: nome, e-mail, telefone e informações inseridas nos orçamentos gerados pelo usuário dentro da plataforma.</li>
        </ul>

        <h4 className="font-bold text-zinc-800 dark:text-slate-200 mt-3 mb-1">2.2. Dados coletados automaticamente</h4>
        <ul className="list-disc pl-5 space-y-1">
          <li>Dados de acesso: endereço IP, data e hora de login, tipo de dispositivo, sistema operacional e navegador ou versão do aplicativo.</li>
          <li>Dados de uso: funcionalidades acessadas, tempo de sessão, ações realizadas na plataforma.</li>
          <li>Cookies e tecnologias similares: utilizados para manutenção de sessão, preferências do usuário e análise de uso.</li>
        </ul>
      </div>

      <div>
        <h3 className="font-bold text-zinc-900 dark:text-white text-sm mb-2">3. BASES LEGAIS DO TRATAMENTO (ART. 7º, LGPD)</h3>
        <p className="mb-2">Todo tratamento de dados realizado pelo R-Max possui uma base legal expressamente prevista na LGPD:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Execução do contrato (art. 7º, V):</strong> para viabilizar o cadastro, a autenticação e o uso das funcionalidades contratadas.</li>
          <li><strong>Legítimo interesse (art. 7º, IX):</strong> para melhoria dos serviços, segurança da plataforma, prevenção a fraudes e análise de uso anonimizada.</li>
          <li><strong>Cumprimento de obrigação legal (art. 7º, II):</strong> para atendimento de determinações judiciais, fiscais e regulatórias.</li>
          <li><strong>Consentimento (art. 7º, I):</strong> para envio de comunicações de marketing, novidades e ofertas comerciais.</li>
        </ul>
      </div>

      <div>
        <h3 className="font-bold text-zinc-900 dark:text-white text-sm mb-2">4. PARA QUE USAMOS OS SEUS DADOS</h3>
        <p className="mb-2">Os dados coletados são utilizados exclusivamente para as seguintes finalidades:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Viabilizar o acesso, o funcionamento e o suporte técnico da plataforma, incluindo autenticação e manutenção de conta.</li>
          <li>Processar e armazenar dados financeiros e comerciais para as funcionalidades de precificação, orçamentos e gestão do negócio.</li>
          <li>Gerar relatórios, histórico de custos e análises de uso disponíveis ao próprio usuário.</li>
          <li>Comunicar ao usuário informações sobre sua conta, alertas do sistema e atualizações relevantes.</li>
          <li>Enviar comunicações de marketing, mediante consentimento do usuário, com opção de cancelamento a qualquer momento.</li>
          <li>Cumprir obrigações legais e regulatórias.</li>
          <li>Proteger a segurança e integridade da plataforma, prevenindo fraudes e acessos não autorizados.</li>
          <li>Aprimorar os serviços com base em dados anonimizados e agregados de uso.</li>
        </ul>
      </div>

      <div>
        <h3 className="font-bold text-zinc-900 dark:text-white text-sm mb-2">5. COMO ARMAZENAMOS E PROTEGEMOS OS SEUS DADOS</h3>
        <p>
          Os dados coletados são armazenados em servidores seguros localizados no Brasil ou em países que ofereçam nível de proteção equivalente ao da LGPD, em conformidade com o art. 33 da Lei nº 13.709/2018. O R-Max adota criptografia de dados em trânsito (TLS/HTTPS) e em repouso, além de controle de acesso baseado em funções (RBAC).
        </p>
      </div>

      <div>
        <h3 className="font-bold text-zinc-900 dark:text-white text-sm mb-2">6. COMPARTILHAMENTO DE DADOS E INTELIGÊNCIA SETORIAL</h3>
        <p>
          O R-Max NÃO vende, não comercializa e não compartilha dados pessoais com terceiros para fins de marketing sem consentimento. O compartilhamento de dados operacionais ocorre apenas com prestadores de serviços tecnológicos contratados (provedores de nuvem, processadores de pagamento) estritamente para a prestação do serviço contratado ou para cumprimento de obrigações legais.
        </p>
        <p className="mt-2">
          <strong>6.1. Programa de Benchmarking e Índices de Mercado:</strong> Mediante opt-in (consentimento) prévio e específico do usuário, o R-Max poderá utilizar dados quantitativos de orçamentos e precificação de forma <strong>estritamente descaracterizada, agrupada por Estado (UF) e irreversivelmente anonimizada</strong>, em plena consonância com o Artigo 12 da Lei nº 13.709/2018 (LGPD), para geração de indicadores econômicos setoriais e relatórios estatísticos (com regra de K-Anonimato mínima de k ≥ 30 prestadores por amostragem). Dados cadastrais, identificadores pessoais, dados sensíveis, fotos e assinaturas são 100% excluídos desse processo.
        </p>
      </div>

      <div>
        <h3 className="font-bold text-zinc-900 dark:text-white text-sm mb-2">7. DADOS DE TERCEIROS INSERIDOS PELO USUÁRIO</h3>
        <p>
          Ao inserir dados de seus clientes finais na plataforma, o usuário passa a atuar como Controlador desses dados, nos termos da LGPD, sendo o responsável por obter o consentimento ou base legal válida para o tratamento. O R-Max atua como Operador desses dados.
        </p>
      </div>

      <div>
        <h3 className="font-bold text-zinc-900 dark:text-white text-sm mb-2">8. PRAZO DE RETENÇÃO DOS DADOS</h3>
        <p>
          Os dados pessoais serão mantidos pelo R-Max durante a vigência da conta e pelos prazos legais subsequentes (geralmente 5 anos para obrigações tributárias e fiscais, ou 6 meses para logs de acesso conforme o Marco Civil da Internet).
        </p>
      </div>

      <div>
        <h3 className="font-bold text-zinc-900 dark:text-white text-sm mb-2">9. DIREITOS DO TITULAR DOS DADOS (ARTS. 17–22, LGPD)</h3>
        <p className="mb-2">Em conformidade com a LGPD, você tem os seguintes direitos em relação aos seus dados pessoais:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Confirmação da existência de tratamento.</li>
          <li>Acesso aos dados pessoais.</li>
          <li>Correção de dados incompletos, inexatos ou desatualizados.</li>
          <li>Anonimização, bloqueio ou eliminação de dados desnecessários ou tratados em desconformidade.</li>
          <li>Portabilidade dos dados mediante requisição expressa.</li>
          <li>Eliminação dos dados pessoais tratados com base no consentimento.</li>
          <li>Revogação do consentimento a qualquer momento.</li>
        </ul>
        <p className="mt-2">
          <strong>9.1. Revogação de Consentimento para Benchmarking de Mercado:</strong> O usuário poderá revogar sua participação a qualquer momento nas configurações da conta. A revogação interrompe a inclusão dos dados a partir dos ciclos e relatórios futuros. Relatórios estatísticos e índices agregados gerados anteriormente, por constituírem dados anonimizados consolidados e irreversíveis (Art. 12 da LGPD), não sofrem alteração retroativa.
        </p>
        <p className="mt-2">
          Para exercer seus direitos, entre em contato pelo e-mail <strong>harpy@resolvmax.com.br</strong>.
        </p>
      </div>

      <div>
        <h3 className="font-bold text-zinc-900 dark:text-white text-sm mb-2">10. COOKIES E TECNOLOGIAS DE RASTREAMENTO</h3>
        <p>
          A plataforma utiliza cookies e tecnologias similares para manter a sessão ativa, armazenar preferências e analisar o uso da plataforma de forma agregada e anonimizada.
        </p>
      </div>

      <div>
        <h3 className="font-bold text-zinc-900 dark:text-white text-sm mb-2">11. TRANSFERÊNCIA INTERNACIONAL DE DADOS</h3>
        <p>
          Caso necessária a transferência de dados para servidores fora do Brasil, o R-Max garantirá a utilização de salvaguardas contratuais adequadas conforme a legislação.
        </p>
      </div>

      <div>
        <h3 className="font-bold text-zinc-900 dark:text-white text-sm mb-2">12. INCIDENTES DE SEGURANÇA</h3>
        <p>
          Em caso de incidente de segurança que possa acarretar risco ou dano relevante aos titulares, o R-Max notificará a ANPD e os usuários afetados no prazo legal.
        </p>
      </div>

      <div>
        <h3 className="font-bold text-zinc-900 dark:text-white text-sm mb-2">13. MENORES DE IDADE, ALTERAÇÕES E CONTATO</h3>
        <h4 className="font-bold text-zinc-800 dark:text-slate-200 mt-2 mb-1">13.1. Menores de Idade</h4>
        <p className="mb-2">
          O R-Max é destinado a maiores de 18 anos. Não coletamos intencionalmente dados de crianças ou adolescentes.
        </p>
        <h4 className="font-bold text-zinc-800 dark:text-slate-200 mt-3 mb-1">13.2. Alterações nesta Política</h4>
        <p className="mb-2">
          Esta política pode ser atualizada. Notificaremos os usuários sobre alterações relevantes com antecedência mínima de 15 dias.
        </p>
        <h4 className="font-bold text-zinc-800 dark:text-slate-200 mt-3 mb-1">13.3. Contato e Encarregado (DPO)</h4>
        <p>
          Encarregado de Dados: Maximiliano Pierin Neto – <strong>harpy@resolvmax.com.br</strong>. Para suporte geral, envie e-mail para <strong>suporte@resolvmax.com.br</strong> ou <strong>contato@resolvmax.com.br</strong>.
        </p>
      </div>
    </div>
  );
}
